import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, router, useForm, usePage } from '@inertiajs/react';
import { useEffect, useMemo } from 'react';

const CreateOrUpdateView = () => {
    const { sector } = usePage().props;
    const { data, setData, errors, post, patch, processing } = useForm({});

    useEffect(() => {
        if (sector?.id) {
            setData(sector);
        }
    }, [sector?.id]);

    const handleSubmit = () => {
        if (!sector?.id) {
            post('/sectors', {
                onSuccess: () => router.reload({ only: ['sector'] }),
            });

            return;
        }

        patch(`/sectors/${sector.id}`);
    };

    const title = useMemo(
        () => (sector?.id ? 'Wijzig sector' : 'Nieuwe sector'),
        [sector]
    );

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/sectors'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup>
                            <Input
                                label='Naam'
                                required
                                value={data?.name || ''}
                                onChange={event =>
                                    setData('name', event?.target?.value)
                                }
                                error={errors?.name}
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
